<template>
  <el-dialog
    title="支付"
    :visible.sync="visible"
    width="527px"
    @close="dialogClose"
    :append-to-body="true"
    border
  >
    <el-card shadow="never" class="aui-card--fill">
      <el-form
        label-width="120px"
        style="padding: 20px 5px 0px"
        ref="form"
        :model="form"
        :rules="dataRule"
      >
        <el-row>
          <el-form-item label="应付金额：">
            <!--<el-input   class="formInputfirst"  v-model="form.payTotal"></el-input><span>￥</span>-->
            <p>
              <span style="color: red; font-weight: bold;font-size: 16px;">{{
                form.payTotal
              }}</span>
              元
            </p>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="支付密码：" prop="paypass" label-width="120px">
            <el-input
              type="password"
              class="formInput"
              placeholder="请输入支付密码"
              v-model="form.paypass"
            ></el-input>
            <span
              style="margin-left: 20px; color: #3877f3; cursor: pointer"
              @click="passwordForget"
              >忘记支付密码</span
            >
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="短信验证码：" prop="code" label-width="120px">
            <el-input
              class="formInput"
              placeholder="请输入验证码"
              v-model="form.code"
            ></el-input>
            <el-button
              type="info"
              style="padding: 0; border: none; margin-left: 20px"
              @click="sendCode"
              v-show="isShow"
              >发送验证码</el-button
            >
            <el-button
              type="info"
              :disabled="false"
              v-show="!isShow"
              style="
                padding: 0;
                width: 100px;
                height: 34px;
                line-height: 34px;
                margin-left: 20px;
              "
              >{{ secondsCount }}秒</el-button
            >
          </el-form-item>
        </el-row>
        <el-row :gutter="20">
          <el-form-item label="验证码：" prop="verificationCode" v-show="true" label-width="120px">
            <el-col :span="14">
              <el-input
                v-model="form.verificationCode"
                :placeholder="$t('login.captcha')"
              >
                <span slot="prefix" class="el-input__icon">
                  <svg class="icon-svg" aria-hidden="true">
                    <use xlink:href="#icon-safetycertificate"></use>
                  </svg>
                </span>
              </el-input>
            </el-col>
            <el-col :span="8" class="login-captcha">
              <img
                :src="captchaPath"
                @click="getCaptcha()"
                style="width: 100%; height: 100%; margin-top: -15px"
              />
            </el-col>
          </el-form-item>
        </el-row>
      </el-form>
    </el-card>

    <span slot="footer" class="dialog-footer">
      <el-button v-no-more-click type="primary" @click="handleSubmit"
        >确 定</el-button
      >
      <el-button @click="cancelPay">取消</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { addDynamicRoute } from "../../../../../router/index";
import aesJs from "../../../../../utils/login-aes";
import { getUUID } from "@/utils";
export default {
  data() {
    return {
      captchaPath: "",
      visible: false,
      form: {
        code: "", //验证码
        paypass: "", //密码
        payRemark: "", //备注信息
        payTotal: 0, //总价
        verificationCode: "", //验证码
      },
      secondsCount: 0, //倒计秒数初始化定义
      isShow: true, //是否显示发送验证码按钮
      isflag: false, //提交
      timer: "", //定时器
      idTotal: [], //id集合
      paymentInfo: [],
    };
  },
  props: ['PaymentInfo'],
  watch: {
    PaymentInfo(newVal) {
      if (!!newVal && newVal.length > 0) {
        this.paymentInfo = newVal[0].id;
      }
    },
  },
  components: {},
  computed: {
    dataRule() {
      return {
        paypass: [
          { required: true, message: "请输入支付密码", trigger: "blur" },
        ],
        code: [{ required: true, message: "请输入验证码", trigger: "blur" }],
        verificationCode: [
          { required: true, message: "验证码", trigger: "blur" },
        ],
      };
    },
  },
  methods: {
    // 获取验证码
    getCaptcha() {
      this.form.uuid = getUUID();
      this.captchaPath = `${window.SITE_CONFIG["apiURL"]}/sys/plat/deal/approval/getVerificationCode?uuid=${this.form.uuid}`;
    },
    init() {
      this.getCaptcha();
      this.visible = true;
    },
    cancelPay() {
      this.$emit("CancelPay", false);
    },
    dialogClose() {
      this.visible = false;
    },
    handleCancel() {
      this.$emit("handleClose", true);
    },
    passwordForget() {
      this.$emit("modifyPayPassword");
    },
    sendCode() {
      //发送短信验证

      this.$http
        .post("sys/plat/deal/approval/pay-send-code", {
          headers: {
            "content-type": "application/json;charset=UTF-8",
          },
        })
        .then((res) => {
          // 倒计时
          if (res.data.code == 0) {
            let that = this;
            // console.log(that)
            that.secondsCount = 60;
            // 切换倒计时按钮
            that.isShow = false;
            // 倒计时函数
            that.timer = setInterval(function () {
              that.secondsCount--;
              if (that.secondsCount <= 0) {
                clearInterval(that.timer);
                that.isShow = true;
              }
            }, 1000);
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    //            提交支付金额
    handleSubmit() {
      this.$refs["form"].validate((valid) => {
          console.log(valid)
        if (!valid) {
          return false;
        }

        let paramsForm = JSON.parse(JSON.stringify(this.form));
        paramsForm.paypass = aesJs.encrypt(paramsForm.paypass);
        this.$http
          .post("/sys/plat/deal/approval/pay", {
            ...paramsForm,
            approvalId: this.PaymentInfo[0].id,
            // ids: this.idTotal,
            code: paramsForm.code,
            paypass: paramsForm.paypass,
            payRemark: paramsForm.payRemark,
          })
          .then(({ data: res }) => {
            // this.form.paypass = aesJs.decrypt(this.form.paypass)
            if (res.code !== 0) {
              this.getCaptcha();
              return this.$message.error(res.msg);
            } else {
              this.dialogClose();
              this.$message.success("操作成功");
              this.$emit("paySuccess");
            }
          });
      });
    },
  }
};
</script>
<style lang="scss" scoped>
.formInputfirst {
  color: red;
  /*/deep/ .el-input__inner{*/
  /*border: 0;*/
  /*}*/
}
.formInput {
  width: 212px;
}
</style>
